export default "__VITE_ASSET__d12pxfDv__"